import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { listProduct, removeProduct } from "../../function/product";
import AdminProductCard from "../../card/AdminProductCard";
import { toast } from "react-toastify";
import ReactTypingEffect from 'react-typing-effect';
import "./HomeAdmin.css"; // นำเข้าไฟล์ stylesheet

const Home = () => {
  const { user } = useSelector((state) => ({ ...state }));
  const [product, setProduct] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoading(true);
    listProduct()
      .then((res) => {
        setLoading(false);
        setProduct(res.data);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const handleRemove = (id) => {
    if (window.confirm("Delete ?")) {
      removeProduct(user.token, id)
        .then((res) => {
          loadData();
          toast.success(`ลบรายการ ${res.data.title} สำเร็จ`);
        })
        .catch((err) => {
          toast.error("ลบรายการไม่สำเร็จ");
          console.log(err);
        });
    }
  };

  return (
    <div className="home-admin-page">
      {loading ? (
        <h1 className="home-admin-loading">Loading....</h1>
      ) : (
        <>
          <div className="home-admin-heading">
            <ReactTypingEffect
              text={['ADMIN 360 HEALTHYSHOP']}
              speed={150}
              eraseDelay={100}
              typingDelay={500}
              className="typingeffect"
              style={{ color: "#FF1493" }}
            />
          </div>

          <div className="home-admin-products">
            {product.map((item) => (
              <div key={item._id} className="home-admin-product-item">
                <AdminProductCard handleRemove={handleRemove} product={item} />
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Home;